import { render } from "./indexwedding.vue?vue&type=template&id=d0bc3406"
import script from "./indexwedding.vue?vue&type=script&lang=js"
export * from "./indexwedding.vue?vue&type=script&lang=js"

import "./indexwedding.vue?vue&type=style&index=0&id=d0bc3406&lang=css"

import exportComponent from "/home/afreet/public_html/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__